import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ICategory, ISpecificationExploreState } from "../types/specification-explore";
import { getProductExplore, getWithSectionProductExplore, getWithSectionProductExplore1, getWithSectionProductExplore2, getWithSectionProductExplore3, getWithSectionProductExplore4, getWithSectionProductExplore5, getWithSectionProductExploreHandler, startProductExplore } from "../thunks/specificationExploreThunk";
import {
  FinishedPart,
  IExploreProduct,
  IExploreSection,
  ISpecificationExploreSection,
  ISpecificationExploreSectionStatus
} from "@/shared/services/interface/responses/ISpecificationExplore";
import {
  getExploreProductToSection
} from "../helper/explore";



const initialState: ISpecificationExploreState = {
  loadingRediscover: false,
  section1: {
    sectionStatus: ISpecificationExploreSectionStatus.DRAFT,
    finishedPart: FinishedPart.LOADING,
    products: []
  },
  section2: {
    sectionStatus: ISpecificationExploreSectionStatus.DRAFT,
    finishedPart: FinishedPart.LOADING,
    products: []
  },
  section3: {
    sectionStatus: ISpecificationExploreSectionStatus.DRAFT,
    finishedPart: FinishedPart.LOADING,
    products: []
  },
  section4: {
    sectionStatus: ISpecificationExploreSectionStatus.DRAFT,
    finishedPart: FinishedPart.LOADING,
    products: []
  },
  section5: {
    sectionStatus: ISpecificationExploreSectionStatus.DRAFT,
    finishedPart: FinishedPart.LOADING,
    products: []
  },
  step1LoadingLast: false,
  step2LoadingLast: false,
  step3LoadingLast: false,
  step4LoadingLast: false,
  step5LoadingLast: false,
  lastSection: 1,
  loadingLastSection: false,
  completedSteps: [],
  filteredProducts: [],
  addedProducts: [],
  removedProducts: [],
  selectedRegion: "f08bd7c9-4c34-4dcb-a61b-0dc85c2b32f6",
  category: {
    category_id: "",
    category_name: "",
    category_url: "",
    created_at: "",
    updated_at: ""
  }
};

export const specificationExploreSlice = createSlice({
  name: "specificationExplore",
  initialState,
  reducers: {
    setAddedPinnedProducts: (state, action: PayloadAction<{ id: string }>) => {
      state.filteredProducts = state.filteredProducts.map((product) => product.id === action.payload.id ? { ...product, isPinned: true } : product);
    },
    setRemovedPinnedProducts: (state, action: PayloadAction<{ id: string }>) => {
      state.filteredProducts = state.filteredProducts.map((product) => product.id === action.payload.id ? { ...product, isPinned: false } : product);
    },
    setAddedProducts: (state, action: PayloadAction<IExploreProduct[]>) => {
      state.addedProducts = action.payload;
    },
    setRemovedProducts: (state, action: PayloadAction<IExploreProduct[]>) => {
      state.removedProducts = action.payload;
    },
    setFilteredProducts: (state, action: PayloadAction<IExploreProduct[]>) => {
      state.filteredProducts = action.payload;
    },
    setLastSection: (state, action: PayloadAction<number>) => {
      state.lastSection = action.payload;
    },
    setCompletedSteps: (state, action: PayloadAction<number[]>) => {
      state.completedSteps = action.payload;
    },
    setStep1LoadingLast: (state, action: PayloadAction<boolean>) => {
      state.step1LoadingLast = action.payload;
    },
    setStep2LoadingLast: (state, action: PayloadAction<boolean>) => {
      state.step2LoadingLast = action.payload;
    },
    setStep3LoadingLast: (state, action: PayloadAction<boolean>) => {
      state.step3LoadingLast = action.payload;
    },
    setStep4LoadingLast: (state, action: PayloadAction<boolean>) => {
      state.step4LoadingLast = action.payload;
    },
    setStep5LoadingLast: (state, action: PayloadAction<boolean>) => {
      state.step5LoadingLast = action.payload;
    },
    setLoadingLastSection: (state, action: PayloadAction<boolean>) => {
      state.loadingLastSection = action.payload;
    },
    setSectionStatus: (
      state,
      action: PayloadAction<{
        section: ISpecificationExploreSection;
        status: ISpecificationExploreSectionStatus;
        finishedPart: FinishedPart;
      }>
    ) => {
      switch (action.payload.section) {
        case ISpecificationExploreSection.MATCHED_PRODUCT:
          state.section1.sectionStatus = action.payload.status;
          state.section1.finishedPart = action.payload.finishedPart;
          break;
        case ISpecificationExploreSection.USER_AND_COMMENT_COUNT:
          state.section2.sectionStatus = action.payload.status;
          state.section2.finishedPart = action.payload.finishedPart;
          break;
        case ISpecificationExploreSection.LOCAL_PARTNER_SUPPORT:
          state.section3.sectionStatus = action.payload.status;
          state.section3.finishedPart = action.payload.finishedPart;
          break;
        case ISpecificationExploreSection.COMPETITIVE_INDEX:
          state.section4.sectionStatus = action.payload.status;
          state.section4.finishedPart = action.payload.finishedPart;
          break;
        case ISpecificationExploreSection.PRODUCER_SCORE:
          state.section5.sectionStatus = action.payload.status;
          state.section5.finishedPart = action.payload.finishedPart;
          break;
      }
    },
    setAllSectionStatus: (state, action: PayloadAction<IExploreSection[]>) => {
      state.section1.sectionStatus = action.payload.filter(
        (item) => item.section === ISpecificationExploreSection.MATCHED_PRODUCT
      )?.[0]?.status || ISpecificationExploreSectionStatus.DRAFT;
      state.section2.sectionStatus = action.payload.filter(
        (item) =>
          item.section === ISpecificationExploreSection.USER_AND_COMMENT_COUNT
      )?.[0]?.status || ISpecificationExploreSectionStatus.DRAFT;
      state.section3.sectionStatus = action.payload.filter(
        (item) =>
          item.section === ISpecificationExploreSection.LOCAL_PARTNER_SUPPORT
      )?.[0]?.status || ISpecificationExploreSectionStatus.DRAFT;
      state.section4.sectionStatus = action.payload.filter(
        (item) =>
          item.section === ISpecificationExploreSection.COMPETITIVE_INDEX
      )?.[0]?.status || ISpecificationExploreSectionStatus.DRAFT;
      state.section5.sectionStatus = action.payload.filter(
        (item) => item.section === ISpecificationExploreSection.PRODUCER_SCORE
      )?.[0]?.status || ISpecificationExploreSectionStatus.DRAFT;
    },
    setProductExploreSection: (
      state,
      action: PayloadAction<{
        section: ISpecificationExploreSection;
        product: IExploreProduct;
      }>
    ) => {
      const { section, product } = action.payload;

      switch (section) {
        case ISpecificationExploreSection.MATCHED_PRODUCT:
          const product1 = state.section1.products.find(
            (item) => item.productId === product.productId
          );
          let newProducts = [...state.section1.products];
          if (product1) {
            newProducts = newProducts.map((item) =>
              item.productId === product.productId ? product : item
            );
          } else {
            newProducts = [...newProducts, product];
          }
          state.section1.products = newProducts;
          break;
        case ISpecificationExploreSection.USER_AND_COMMENT_COUNT:
          const product2 = state.section2.products.find(
            (item) => item.productId === product.productId
          );
          let newProducts2 = [...state.section2.products];
          if (product2) {
            newProducts2 = newProducts2.map((item) =>
              item.productId === product.productId ? product : item
            );
          } else {
            newProducts2 = [...newProducts2, product];
          }
          state.section2.products = newProducts2;
          break;
        case ISpecificationExploreSection.LOCAL_PARTNER_SUPPORT:
          const product3 = state.section3.products.find(
            (item) => item.productId === product.productId
          );
          let newProducts3 = [...state.section3.products];
          if (product3) {
            newProducts3 = newProducts3.map((item) =>
              item.productId === product.productId ? product : item
            );
          } else {
            newProducts3 = [...newProducts3, product];
          }
          state.section3.products = newProducts3;
          break;
        case ISpecificationExploreSection.COMPETITIVE_INDEX:
          const product4 = state.section4.products.find(
            (item) => item.productId === product.productId
          );
          let newProducts4 = [...state.section4.products];
          if (product4) {
            newProducts4 = newProducts4.map((item) =>
              item.productId === product.productId ? product : item
            );
          } else {
            newProducts4 = [...newProducts4, product];
          }
          state.section4.products = newProducts4;
          break;
        case ISpecificationExploreSection.PRODUCER_SCORE:
          const product5 = state.section5.products.find(
            (item) => item.productId === product.productId
          );
          let newProducts5 = [...state.section5.products];
          if (product5) {
            newProducts5 = newProducts5.map((item) =>
              item.productId === product.productId ? product : item
            );
          } else {
            newProducts5 = [...newProducts5, product];
          }
          state.section5.products = newProducts5;
          break;
      }
    },
    setAllProductExploreSection: (state, action: PayloadAction<{
      section: ISpecificationExploreSection;
      products: IExploreProduct[];
    }>) => {
      if (action.payload.section === ISpecificationExploreSection.MATCHED_PRODUCT) {
        state.section1.products = action.payload.products;
      } else if (action.payload.section === ISpecificationExploreSection.USER_AND_COMMENT_COUNT) {
        state.section2.products = action.payload.products;
      } else if (action.payload.section === ISpecificationExploreSection.LOCAL_PARTNER_SUPPORT) {
        state.section3.products = action.payload.products;
      } else if (action.payload.section === ISpecificationExploreSection.COMPETITIVE_INDEX) {
        state.section4.products = action.payload.products;
      } else if (action.payload.section === ISpecificationExploreSection.PRODUCER_SCORE) {
        state.section5.products = action.payload.products;
      }
    },
    setCategory: (state, action: PayloadAction<ICategory>) => {
      state.category = action.payload;
    },
    clearAll(state) {
      state.section1 = {
        sectionStatus: ISpecificationExploreSectionStatus.DRAFT,
        finishedPart: FinishedPart.LOADING,
        products: []
      };
      state.section2 = {
        sectionStatus: ISpecificationExploreSectionStatus.DRAFT,
        finishedPart: FinishedPart.LOADING,
        products: []
      };
      state.section3 = {
        sectionStatus: ISpecificationExploreSectionStatus.DRAFT,
        finishedPart: FinishedPart.LOADING,
        products: []
      };
      state.section4 = {
        sectionStatus: ISpecificationExploreSectionStatus.DRAFT,
        finishedPart: FinishedPart.LOADING,
        products: []
      };
      state.section5 = {
        sectionStatus: ISpecificationExploreSectionStatus.DRAFT,
        finishedPart: FinishedPart.LOADING,
        products: []
      };
      state.completedSteps = [];
      state.lastSection = 1;
      state.step1LoadingLast = false;
      state.step2LoadingLast = false;
      state.step3LoadingLast = false;
      state.step4LoadingLast = false;
      state.step5LoadingLast = false;
      state.category = {
        category_id: "",
        category_name: "",
        category_url: "",
        created_at: "",
        updated_at: ""
      };
    },
    setSelectedRegion: (state, action: PayloadAction<string | null>) => {
      state.selectedRegion = action.payload;
    },
    setInitialState: (state, action) => {
      state.filteredProducts = [];
      state.addedProducts = [];
      state.removedProducts = [];
      state.selectedRegion = action.payload.selectedRegion;
      state.lastSection = 1;
      state.loadingLastSection = false;
      state.completedSteps = [];
      state.step1LoadingLast = false;
      state.step2LoadingLast = false;
      state.step3LoadingLast = false;
      state.step4LoadingLast = false;
      state.step5LoadingLast = false;
      state.completedSteps = [];
      state.section1 = {
        sectionStatus: ISpecificationExploreSectionStatus.DRAFT,
        finishedPart: FinishedPart.LOADING,
        products: []
      };

      state.section2 = {
        sectionStatus: ISpecificationExploreSectionStatus.DRAFT,
        finishedPart: FinishedPart.LOADING,
        products: []
      };

      state.section3 = {
        sectionStatus: ISpecificationExploreSectionStatus.DRAFT,
        finishedPart: FinishedPart.LOADING,
        products: []
      };
      state.section4 = {
        sectionStatus: ISpecificationExploreSectionStatus.DRAFT,
        finishedPart: FinishedPart.LOADING,
        products: []
      };
      state.section5 = {
        sectionStatus: ISpecificationExploreSectionStatus.DRAFT,
        finishedPart: FinishedPart.LOADING,
        products: []
      };
      state.category = {
        category_id: "",
        category_name: "",
        category_url: "",
        created_at: "",
        updated_at: ""
      };

    }
  },
  extraReducers: (builder) => {

    builder.addCase(getProductExplore.fulfilled, (state, action) => {
      const { section1, section2, section3, section4, section5 } =
        getExploreProductToSection(action.payload);
      state.section1.products = section1;
      state.section2.products = section2;
      state.section3.products = section3;
      state.section4.products = section4;
      state.section5.products = section5;
    });
    builder.addCase(getWithSectionProductExplore.fulfilled, (state, action) => {

      switch (action.payload.section) {
        case 1:
          state.section1.products = action.payload.data;
          break;
        case 2:
          state.section2.products = action.payload.data;
          break;
        case 3:
          state.section3.products = action.payload.data;
          break;
        case 4:
          state.section4.products = action.payload.data;
          break;
        case 5:
          state.section5.products = action.payload.data;
          break;
      }
    });
    builder.addCase(getWithSectionProductExplore1.fulfilled, (state, action) => {
      const payloadData = action.payload as any;
      state.section1.products = payloadData.data;
      state.category = payloadData.productCategory;
    });
    builder.addCase(getWithSectionProductExploreHandler.fulfilled, (state, action) => {
      const payloadData = action.payload as any;
      switch (payloadData.section) {
        case 1:
          state.section1.products = payloadData.data;
          state.addedProducts = [];
          state.removedProducts = [];
          break;
        case 2:
          state.section2.products = payloadData.data;
          state.addedProducts = [];
          state.removedProducts = [];
          break;
        case 3:
          state.section3.products = payloadData.data;
          state.addedProducts = [];
          state.removedProducts = [];
          break;
        case 4:
          state.section4.products = payloadData.data;
          state.addedProducts = [];
          state.removedProducts = [];
          break;
        case 5:
          state.section5.products = payloadData.data;
          state.addedProducts = [];
          state.removedProducts = [];
          break;
        default:
          state.addedProducts = [];
          state.removedProducts = [];
          break;
      }
    });
    builder.addCase(getWithSectionProductExplore2.fulfilled, (state, action) => {
      state.addedProducts = [];
      state.removedProducts = [];
      state.section2.products = action.payload;
    });
    builder.addCase(getWithSectionProductExplore3.fulfilled, (state, action) => {
      state.addedProducts = [];
      state.removedProducts = [];
      state.section3.products = action.payload;
    });
    builder.addCase(getWithSectionProductExplore4.fulfilled, (state, action) => {
      state.addedProducts = [];
      state.removedProducts = [];
      state.section4.products = action.payload;
    });
    builder.addCase(getWithSectionProductExplore5.fulfilled, (state, action) => {
      state.addedProducts = [];
      state.removedProducts = [];
      state.section5.products = action.payload;
    });
    builder.addCase(startProductExplore.pending, (state, action) => {
      if (action.meta.arg.isRediscover) {
        state.loadingRediscover = true;
      }
      state.loadingLastSection = true;
    });
    builder.addCase(startProductExplore.fulfilled, (state, action) => {
      state.lastSection = action.payload.section;
      state.loadingLastSection = true;
      state.loadingRediscover = false;
    });
    builder.addCase(startProductExplore.rejected, (state) => {
      state.loadingLastSection = false;
      state.loadingRediscover = false;
    });
  }
});

export const {
  setAllSectionStatus,
  setSectionStatus,
  setProductExploreSection,
  setAllProductExploreSection,
  clearAll,
  setStep1LoadingLast,
  setStep2LoadingLast,
  setStep3LoadingLast,
  setStep4LoadingLast,
  setStep5LoadingLast,
  setLoadingLastSection,
  setCompletedSteps,
  setCategory,
  setLastSection,
  setSelectedRegion,
  setFilteredProducts,
  setAddedProducts,
  setRemovedProducts,
  setAddedPinnedProducts,
  setRemovedPinnedProducts,
  setInitialState
} = specificationExploreSlice.actions;
export default specificationExploreSlice.reducer;
